/* ==========================================================================
   Envío visible — De Todo y Más
   2026-09-20 · rev 5

   SPEC 01 · Barra de progreso hacia el envío gratis
   SPEC 02 · Calculadora de despacho en el carro
   SPEC 03 · Despacho en la ficha de producto
   SPEC 04 · Armado de muebles a domicilio (solo RM)

   Configuración: snippets/envio-gratis-bar.liquid
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('eg-config');
  if (!cfgEl) return;

  var CFG = {
    threshold: parseInt(cfgEl.getAttribute('data-threshold'), 10) || 59990,
    zones: cfgEl.getAttribute('data-zones') || '',
    freeRegions: (cfgEl.getAttribute('data-free-regions') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
    whatsapp: cfgEl.getAttribute('data-whatsapp') || '',
    compactCart: cfgEl.getAttribute('data-compact-cart') !== 'false',
    initialTotal: parseInt(cfgEl.getAttribute('data-cart-total'), 10) || 0,

    // Servicio de armado a domicilio (spec 04)
    armVariant: cfgEl.getAttribute('data-armado-variant') || '',
    armPrice: parseInt(cfgEl.getAttribute('data-armado-precio'), 10) || 0,
    armRegion: cfgEl.getAttribute('data-armado-region') || '',
    armTypes: (cfgEl.getAttribute('data-armado-tipos') || '').split(',').map(function (s) {
      return normalize(s);
    }).filter(Boolean)
  };

  // [valor que acepta la API, etiqueta visible, ciudad de referencia]
  //
  // Los valores de la primera columna son los nombres EXACTOS que acepta
  // /cart/shipping_rates.json (verificados uno por uno contra la API el
  // 19-09-2026). Cambiar cualquiera rompe el cálculo.
  //
  // La tercera columna es obligatoria: sin una ciudad, Shipit devuelve una
  // lista vacía de tarifas. Usamos la capital regional como referencia.
  var REGIONS = [
    ['Arica y Parinacota', 'Arica y Parinacota', 'Arica'],
    ['Tarapacá', 'Tarapacá', 'Iquique'],
    ['Antofagasta', 'Antofagasta', 'Antofagasta'],
    ['Atacama', 'Atacama', 'Copiapó'],
    ['Coquimbo', 'Coquimbo', 'La Serena'],
    ['Valparaíso', 'Valparaíso', 'Valparaíso'],
    ['Región Metropolitana de Santiago', 'Metropolitana de Santiago', 'Santiago'],
    ["O'Higgins", "O'Higgins", 'Rancagua'],
    ['Maule', 'Maule', 'Talca'],
    ['Ñuble', 'Ñuble', 'Chillán'],
    ['Biobío', 'Biobío', 'Concepción'],
    ['Araucanía', 'Araucanía', 'Temuco'],
    ['Los Ríos', 'Los Ríos', 'Valdivia'],
    ['Los Lagos', 'Los Lagos', 'Puerto Montt'],
    ['Aysén', 'Aysén', 'Coyhaique'],
    ['Magallanes', 'Magallanes', 'Punta Arenas']
  ];

  var STORE_KEY = 'eg-region';

  var SLOTS = [
    '.shoppingcart-content .wrap-cart',
    '#js_cart_popup .box-cart',
    '.mini_cart_content'
  ];

  /* ======================================================================
     Utilidades
     ====================================================================== */

  // $184.990 — punto de miles, sin decimales (formato chileno)
  function money(value) {
    try {
      return '$' + Math.round(value).toLocaleString('es-CL');
    } catch (e) {
      return '$' + Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  function esc(str) {
    return String(str).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // minúsculas y sin tildes, para comparar "Estanterías" con "estanteria"
  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function getRegion() {
    try { return localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; }
  }

  function setRegion(v) {
    try { localStorage.setItem(STORE_KEY, v); } catch (e) {}
  }

  function regionLabel(value) {
    for (var i = 0; i < REGIONS.length; i++) {
      if (REGIONS[i][0] === value) return REGIONS[i][1];
    }
    return value;
  }

  function regionCity(value) {
    for (var i = 0; i < REGIONS.length; i++) {
      if (REGIONS[i][0] === value) return REGIONS[i][2];
    }
    return 'Santiago';
  }

  function regionIsFree(value) {
    return CFG.freeRegions.indexOf(value) !== -1;
  }

  // Mientras escribimos en el DOM ignoramos nuestras propias mutaciones,
  // si no los observadores se disparan solos en bucle.
  var writing = false;
  function ignoreOwnWrites(fn) {
    return function () { if (writing) return; fn(); };
  }

  var cartTotal = CFG.initialTotal; // en centavos, como lo entrega Shopify
  var cartItems = [];

  // El servicio de armado no debe contar para el umbral de envío gratis:
  // si contara, $10.000 de mano de obra acercarían el carro al despacho
  // gratis sin que el cliente comprara un peso más de mercadería.
  function goodsTotal() {
    var total = cartTotal || 0;
    cartItems.forEach(function (item) {
      if (isArmadoItem(item)) total -= item.line_price;
    });
    return Math.max(0, total);
  }

  /* ======================================================================
     SPEC 01 — barra de progreso
     ====================================================================== */

  function slots() {
    var found = [];
    SLOTS.forEach(function (sel) {
      var host = document.querySelector(sel);
      if (!host) return;
      var bar = host.querySelector(':scope > .eg-bar');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'eg-bar';
        bar.setAttribute('role', 'status');
        bar.setAttribute('aria-live', 'polite');
        host.insertBefore(bar, host.firstChild);
      }
      found.push(bar);
    });
    return found;
  }

  function renderBar() {
    writing = true;

    var bars = slots();
    if (!bars.length) { writing = false; return; }

    var total = goodsTotal() / 100;
    var missing = CFG.threshold - total;
    var done = missing <= 0;
    var empty = total <= 0;
    var region = getRegion();
    var outsideZone = region && !regionIsFree(region);

    // Firma del estado: si no cambió, no tocamos el DOM.
    var key = empty ? 'vacio'
      : outsideZone ? 'region:' + region
      : done ? 'done'
      : 'falta:' + Math.round(missing);

    var html = '';
    if (!empty) {
      if (outsideZone) {
        html =
          '<p class="eg-bar__msg"><b>Despacho a ' + esc(regionLabel(region)) + '.</b> ' +
          'El envío gratis aplica en ' + esc(CFG.zones) + '. Calcula tu despacho más abajo.</p>';
      } else if (done) {
        html =
          '<p class="eg-bar__msg">✓ <b>¡Tienes envío gratis!</b> Tu pedido llega sin costo de despacho.</p>' +
          '<div class="eg-bar__track"><i class="eg-bar__fill" style="width:100%"></i></div>' +
          (CFG.zones ? '<p class="eg-bar__note">Aplica en ' + esc(CFG.zones) + '.</p>' : '');
      } else {
        var pct = Math.max(2, Math.min(100, (total / CFG.threshold) * 100));
        html =
          '<p class="eg-bar__msg">Te faltan <b>' + money(missing) + '</b> para envío gratis</p>' +
          '<div class="eg-bar__track"><i class="eg-bar__fill" style="width:' + pct.toFixed(1) + '%"></i></div>' +
          (CFG.zones ? '<p class="eg-bar__note">Envío gratis en ' + esc(CFG.zones) + '.</p>' : '');
      }
    }

    bars.forEach(function (bar) {
      if (bar.getAttribute('data-eg-state') === key) return;
      bar.setAttribute('data-eg-state', key);
      bar.className = 'eg-bar' + (done && !empty && !outsideZone ? ' is-done' : '');
      bar.innerHTML = html;
    });

    setTimeout(function () { writing = false; }, 0);
  }

  /* ======================================================================
     SPEC 02 — calculadora de despacho
     ====================================================================== */

  var ratesCache = {};   // clave: region + '|' + totalCarro
  var calcEl = null;

  function buildCalc() {
    var host = document.querySelector('.content.cart-total');
    if (!host) return null;

    var existing = host.querySelector('.eg-calc');
    if (existing) return existing;

    var box = document.createElement('div');
    box.className = 'eg-calc';

    var opts = '<option value="">Elige tu región…</option>';
    REGIONS.forEach(function (r) {
      opts += '<option value="' + esc(r[0]) + '">' + esc(r[1]) + '</option>';
    });

    box.innerHTML =
      '<h5 class="eg-calc__title">Calcula tu despacho</h5>' +
      '<select class="eg-calc__select" id="eg-region-select" aria-label="Región de despacho">' + opts + '</select>' +
      '<div class="eg-calc__out" aria-live="polite"></div>';

    // Va justo antes de la nota "Impuestos y gastos de envío calculados al pagar"
    var anchor = host.querySelector('.cart__shipping_note') || host.querySelector('.group-button');
    if (anchor) host.insertBefore(box, anchor);
    else host.appendChild(box);

    var select = box.querySelector('.eg-calc__select');
    select.addEventListener('change', function () {
      setRegion(select.value);
      renderBar();
      updateCalc();
      renderArmado();
    });

    return box;
  }

  function fetchRates(region) {
    var key = region + '|' + cartTotal;
    if (ratesCache[key]) return Promise.resolve(ratesCache[key]);

    // Ojo: la ciudad NO puede ir vacía o Shipit devuelve cero tarifas.
    var url = '/cart/shipping_rates.json' +
      '?shipping_address%5Bcountry%5D=Chile' +
      '&shipping_address%5Bcity%5D=' + encodeURIComponent(regionCity(region)) +
      '&shipping_address%5Bzip%5D=' +
      '&shipping_address%5Bprovince%5D=' + encodeURIComponent(region);

    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var rates = (j && j.shipping_rates) || null;
        if (rates) ratesCache[key] = rates;
        return rates;
      })
      .catch(function () { return null; });
  }

  function cleanRateName(name) {
    var n = String(name || '').replace(/^\s*shipit\s*:\s*/i, '').trim();
    return n.charAt(0).toUpperCase() + n.slice(1);
  }

  function shippingNote(show) {
    var note = document.querySelector('.content.cart-total .cart__shipping_note');
    if (note) note.style.display = show ? '' : 'none';
  }

  function updateCalc() {
    var box = calcEl || (calcEl = buildCalc());
    if (!box) return;

    var select = box.querySelector('.eg-calc__select');
    var out = box.querySelector('.eg-calc__out');
    var region = getRegion();

    if (select.value !== region) select.value = region;

    if (!region) {
      out.innerHTML = '';
      shippingNote(true);
      return;
    }

    out.innerHTML = '<p class="eg-calc__loading">Calculando despacho a ' + esc(regionLabel(region)) + '…</p>';

    fetchRates(region).then(function (rates) {
      if (getRegion() !== region) return; // el cliente cambió de región mientras tanto

      if (!rates || !rates.length) {
        out.innerHTML =
          '<p class="eg-calc__error">No pudimos calcular el despacho a ' + esc(regionLabel(region)) + '.' +
          (CFG.whatsapp
            ? ' <a href="https://wa.me/' + esc(CFG.whatsapp) + '" target="_blank" rel="noopener">Escríbenos por WhatsApp</a>'
            : '') +
          '</p>';
        shippingNote(true);
        return;
      }

      // La más barata primero
      var sorted = rates.slice().sort(function (a, b) {
        return parseInt(a.price, 10) - parseInt(b.price, 10);
      });
      var best = sorted[0];
      var bestPrice = parseInt(best.price, 10); // en pesos, no centavos
      var free = bestPrice === 0;

      function row(r, best) {
        var price = parseInt(r.price, 10);
        return '<div class="eg-calc__row' + (best ? ' is-best' : '') + '">' +
          '<span>' + esc(cleanRateName(r.name)) + '</span>' +
          '<b class="' + (price === 0 ? 'eg-calc__free' : '') + '">' +
          (price === 0 ? 'Gratis' : money(price)) + '</b>' +
          '</div>';
      }

      // Shipit devuelve hasta 5 couriers por región. Mostramos el más barato,
      // que es el que usamos para el total, y dejamos el resto plegado para no
      // asustar con la tarifa más cara.
      var others = sorted.slice(1);
      var extra = others.length
        ? '<details class="eg-calc__more"><summary>Otras ' + others.length + ' opciones de despacho</summary>' +
          others.map(function (r) { return row(r, false); }).join('') +
          '</details>'
        : '';

      var estimate = (cartTotal / 100) + bestPrice;

      out.innerHTML =
        '<div class="eg-calc__res">' + row(best, true) + extra +
        '<div class="eg-calc__row eg-calc__row--total">' +
        '<span>Total estimado</span><b>' + money(estimate) + '</b>' +
        '</div></div>' +
        (free ? '' : '<p class="eg-calc__note">Valor referencial. Se confirma en el pago.</p>');

      shippingNote(false);
    });
  }

  /* ======================================================================
     Carro compacto — el botón de pago visible sin scroll
     ======================================================================
     Dos ajustes, ninguno destructivo:
       1. Oculta el campo de cupón, que solo informa que el código se
          aplica en la página de pago.
       2. Pliega la nota del pedido y la manda bajo el botón de pago.
          El textarea sigue dentro de <form class="cart">, así que el
          campo "note" se envía igual que antes.

     Motivo: en 50 pedidos revisados, 2 traían nota (4%). Esa caja abierta
     de ~100px empujaba el botón COMPRAR bajo el fold en mobile.
     ====================================================================== */

  function tidyCart() {
    if (!CFG.compactCart) return;

    var total = document.querySelector('.content.cart-total');
    if (!total) return;

    var coupon = total.querySelector('.info-coupon');
    if (coupon) coupon.style.display = 'none';

    var note = document.querySelector('.add-order-note');
    var btns = total.querySelector('.group-button');
    if (!note || !btns) return;
    if (note.parentNode && note.parentNode.className === 'eg-note') return; // ya movida

    // El bloque trae su propio título; lo reemplaza el <summary>.
    [].forEach.call(note.children, function (child) {
      if (/NOTA DE PEDIDO/i.test(child.textContent || '')) child.style.display = 'none';
    });

    var det = document.createElement('details');
    det.className = 'eg-note';
    var sum = document.createElement('summary');
    sum.textContent = 'Agregar una nota al pedido';
    det.appendChild(sum);
    det.appendChild(note);

    btns.parentNode.insertBefore(det, btns.nextSibling);
  }

  /* ======================================================================
     SPEC 04 — armado de muebles a domicilio
     ======================================================================
     Un checkbox sobre el botón COMPRAR que agrega o quita el SKU del
     servicio. Shopify solo permite bloques DENTRO del checkout en el plan
     Plus; el carro es lo más cerca del pago que se puede llegar en Advanced.

     El armado se terceriza y el precio cerrado solo existe en
     data-armado-region. En el resto del país no se ofrece aquí: se atiende
     por WhatsApp caso a caso, fuera de la tienda.

     Tres reglas:
       1. Solo aparece si el carro trae al menos un mueble (se compara el
          product_type del item contra data-armado-tipos).
       2. Solo aparece si la región elegida es la que tiene tarifa, o si el
          cliente todavía no elige región.
       3. Si el cliente cambia a otra región, el servicio se saca del carro
          solo. Cobrar la tarifa de Santiago por un armado en Punta Arenas
          sería vender a pérdida.
     ====================================================================== */

  var armEl = null;
  var armBusy = false;

  function isArmadoItem(item) {
    return CFG.armVariant && String(item.variant_id) === String(CFG.armVariant);
  }

  function cartHasMueble() {
    return cartItems.some(function (item) {
      if (isArmadoItem(item)) return false;
      var type = normalize(item.product_type);
      if (!type) return false;
      return CFG.armTypes.some(function (kw) { return type.indexOf(kw) !== -1; });
    });
  }

  function armadoInCart() {
    return cartItems.some(isArmadoItem);
  }

  // Sin región elegida asumimos que está en cobertura: la mayoría de los
  // pedidos son de la RM y es mejor mostrar la oferta que esconderla.
  function armadoEnCobertura() {
    var region = getRegion();
    return !region || !CFG.armRegion || region === CFG.armRegion;
  }

  function buildArmado() {
    var host = document.querySelector('.content.cart-total');
    if (!host) return null;

    var existing = host.querySelector('.eg-arm');
    if (existing) return existing;

    var box = document.createElement('div');
    box.className = 'eg-arm';
    box.hidden = true;
    box.innerHTML =
      '<label class="eg-arm__row">' +
      '<input type="checkbox" class="eg-arm__check">' +
      '<span class="eg-arm__body">' +
      '<b class="eg-arm__title">¿Prefieres que lo armemos nosotros?</b>' +
      '<span class="eg-arm__desc">Armado a domicilio, rápido y sin enredos. ' +
      'Coordinamos día y hora por WhatsApp después de tu compra.</span>' +
      '</span>' +
      '<b class="eg-arm__price">+' + money(CFG.armPrice) + '</b>' +
      '</label>' +
      '<div class="eg-arm__quote"></div>' +
      '<p class="eg-arm__state" aria-live="polite"></p>';

    var anchor = host.querySelector('.group-button');
    if (anchor) host.insertBefore(box, anchor);
    else host.appendChild(box);

    box.querySelector('.eg-arm__check').addEventListener('change', function (e) {
      toggleArmado(e.target.checked);
    });

    return box;
  }

  function toggleArmado(add) {
    if (armBusy || !CFG.armVariant) return;
    armBusy = true;

    var state = armEl && armEl.querySelector('.eg-arm__state');
    if (state) state.textContent = add ? 'Agregando el armado…' : 'Quitando el armado…';

    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var req = add
      ? fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: json,
          body: JSON.stringify({ items: [{ id: Number(CFG.armVariant), quantity: 1 }] })
        })
      : fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: json,
          body: JSON.stringify({ id: String(CFG.armVariant), quantity: 0 })
        });

    req
      .then(function () { armBusy = false; return refresh(); })
      .then(function () {
        if (state) state.textContent = '';
        // El total cambió: que el tema repinte su propio bloque.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        armBusy = false;
        if (state) state.textContent = 'No pudimos actualizar el carro. Inténtalo otra vez.';
      });
  }

  function renderArmado() {
    if (!CFG.armVariant) return;

    var box = armEl || (armEl = buildArmado());
    if (!box) return;

    var enCobertura = armadoEnCobertura();
    var enCarro = armadoInCart();

    // Fuera de cobertura con el servicio adentro: lo sacamos.
    if (!enCobertura && enCarro && !armBusy) {
      box.hidden = true;
      toggleArmado(false);
      return;
    }

    var mostrar = cartHasMueble() && enCobertura;
    box.hidden = !mostrar;
    if (!mostrar) return;

    box.className = 'eg-arm' + (enCarro ? ' is-on' : '');

    // Mientras no elija región, avisamos dónde vale el precio.
    box.querySelector('.eg-arm__quote').innerHTML = getRegion()
      ? ''
      : '<p class="eg-arm__hint">Servicio disponible en ' +
        esc(regionLabel(CFG.armRegion)) + '.</p>';

    var check = box.querySelector('.eg-arm__check');
    if (check.checked !== enCarro) check.checked = enCarro;
  }

  /* ======================================================================
     SPEC 03 — ficha de producto
     ====================================================================== */

  var pdpEl = null;
  var productPrice = null;   // en pesos

  function isProductPage() {
    return location.pathname.indexOf('/products/') !== -1;
  }

  // Corrige los textos que prometen envío gratis sin decir en qué regiones.
  // Se ejecuta en todas las páginas.
  function fixShippingCopy() {
    if (!CFG.zones) return;

    // Franja de beneficios del footer: "Envíos gratis desde $59.990"
    var re = /^Env[ií]os? gratis desde \$[\d.,]+$/;
    [].forEach.call(document.querySelectorAll('p, span, div, li'), function (el) {
      if (el.children.length) return;
      var txt = (el.textContent || '').trim();
      if (re.test(txt)) el.textContent = txt + ' en ' + CFG.zones;
    });

    // Nota de la ficha: "Despacho gratis sobre $59.990 de la V a VII región"
    var nota = document.querySelector('.product__text');
    if (nota && /Despacho gratis sobre/i.test(nota.textContent)) {
      nota.textContent = 'Envío gratis desde ' + money(CFG.threshold) + ' en ' + CFG.zones;
    }
  }

  function buildPdp() {
    if (!isProductPage()) return null;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || !form.parentNode) return null;

    var existing = document.querySelector('.eg-pdp');
    if (existing) return existing;

    var box = document.createElement('div');
    box.className = 'eg-pdp';

    var opts = '<option value="">Elige tu región…</option>';
    REGIONS.forEach(function (r) {
      opts += '<option value="' + esc(r[0]) + '">' + esc(r[1]) + '</option>';
    });

    box.innerHTML =
      '<div class="eg-pdp__head">' +
      '<span class="eg-pdp__label">Despacho a</span>' +
      '<select class="eg-pdp__select" aria-label="Región de despacho">' + opts + '</select>' +
      '</div>' +
      '<div class="eg-pdp__out" aria-live="polite"></div>';

    form.parentNode.insertBefore(box, form.nextSibling);

    var select = box.querySelector('.eg-pdp__select');
    select.addEventListener('change', function () {
      setRegion(select.value);
      updatePdp();
      renderBar();
    });

    return box;
  }

  function updatePdp() {
    var box = pdpEl || (pdpEl = buildPdp());
    if (!box) return;

    var select = box.querySelector('.eg-pdp__select');
    var out = box.querySelector('.eg-pdp__out');
    var region = getRegion();

    if (select.value !== region) select.value = region;

    if (!region) {
      out.innerHTML = '<p class="eg-pdp__msg eg-pdp__msg--muted">Elige tu región para saber si tu pedido lleva despacho gratis.</p>';
      return;
    }

    if (productPrice === null) {
      out.innerHTML = '<p class="eg-pdp__msg eg-pdp__msg--muted">Calculando…</p>';
      return;
    }

    if (!regionIsFree(region)) {
      out.innerHTML =
        '<p class="eg-pdp__msg">El despacho a <b>' + esc(regionLabel(region)) + '</b> tiene costo. ' +
        'Lo calculas en el carro, antes de pagar.</p>' +
        '<p class="eg-pdp__note">El envío gratis aplica en ' + esc(CFG.zones) + '.</p>';
      return;
    }

    var missing = CFG.threshold - productPrice;
    if (missing <= 0) {
      out.innerHTML =
        '<p class="eg-pdp__msg eg-pdp__msg--ok">✓ <b>Despacho gratis</b> a ' + esc(regionLabel(region)) + '.</p>';
    } else {
      out.innerHTML =
        '<p class="eg-pdp__msg">Te faltan <b>' + money(missing) + '</b> para despacho gratis a ' +
        esc(regionLabel(region)) + '.</p>' +
        '<p class="eg-pdp__note">Envío gratis desde ' + money(CFG.threshold) + '.</p>';
    }
  }

  function loadProductPrice() {
    if (!isProductPage() || productPrice !== null) return;
    fetch(location.pathname.split('?')[0] + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (p && typeof p.price === 'number') {
          productPrice = p.price / 100;
          updatePdp();
        }
      })
      .catch(function () {});
  }

  /* ======================================================================
     Lectura del carro
     ====================================================================== */

  var pending = null;

  function refresh() {
    if (pending) return pending;
    pending = fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartTotal = cart.total_price;
        cartItems = cart.items || [];
        renderBar();
        updateCalc();
        tidyCart();
        renderArmado();
      })
      .catch(function () { /* silencio: la barra simplemente no cambia */ })
      .then(function () { pending = null; });
    return pending;
  }

  var refreshTimer = null;
  function refreshSoon() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 250);
  }

  /* ======================================================================
     Detección de cambios en el carro
     ====================================================================== */

  var CART_ROUTE = /\/cart\/(add|change|update|clear)/;

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var out = _fetch.apply(this, arguments);
      if (CART_ROUTE.test(url)) out.then(refreshSoon, function () {});
      return out;
    };
  }

  // XMLHttpRequest (el tema usa jQuery en varias partes)
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      if (CART_ROUTE.test(url || '')) refreshSoon();
    });
    return _open.apply(this, arguments);
  };

  var counter = document.querySelector('.js-cart-count');
  if (counter && window.MutationObserver) {
    new MutationObserver(ignoreOwnWrites(refreshSoon)).observe(counter, {
      childList: true, characterData: true, subtree: true
    });
  }

  // El drawer se vuelve a pintar al abrirlo y tras cada cambio: reinyectamos.
  ['#js_cart_popup', '.laber_mini_cart'].forEach(function (sel) {
    var host = document.querySelector(sel);
    if (host && window.MutationObserver) {
      new MutationObserver(ignoreOwnWrites(refreshSoon)).observe(host, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
    }
  });

  document.addEventListener('cart:updated', refreshSoon);
  document.addEventListener('cart:refresh', refreshSoon);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshSoon(); });

  /* ======================================================================
     Cinta del header
     ====================================================================== */

  var ribbon = document.querySelector('.eg-ribbon');
  if (ribbon) {
    var KEY = 'eg-ribbon-cerrada';
    var hidden = false;
    try { hidden = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (hidden) {
      ribbon.hidden = true;
    } else {
      var close = ribbon.querySelector('.eg-ribbon__close');
      if (close) {
        close.addEventListener('click', function () {
          ribbon.hidden = true;
          try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
        });
      }
    }
  }

  /* ======================================================================
     Arranque
     ====================================================================== */
  // Pintamos con el total que vino del servidor para evitar el parpadeo,
  // y confirmamos con /cart.js por si el carro cambió en otra pestaña.
  fixShippingCopy();
  tidyCart();
  renderBar();
  updateCalc();
  renderArmado();
  updatePdp();
  loadProductPrice();
  refreshSoon();
})();
